import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0df54758"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "card-list-wrap"
}
const _hoisted_2 = ["onClick"]
const _hoisted_3 = { class: "card-item-img" }
const _hoisted_4 = { class: "card-item-content" }
const _hoisted_5 = { class: "title" }
const _hoisted_6 = { class: "extension-info" }
const _hoisted_7 = { class: "extension-info" }

import CommonTitleTemplate from './common-title-template.vue';
import Ellipsis from '@/components/ellipsis.vue';
import BigNoData from '@/components/no-data.vue';
import LazyImage from '@/components/lazy-image/lazy-image.vue';
import CodeDialog from '@/views/shenzhen/components/code-dialog.vue';
import { computed, onMounted, PropType, reactive, ref } from 'vue';
import { isObject, isString, result } from 'lodash';
import { pageJump } from '@/global/location-transfer';
import { jumpHref } from '@/router/jumpHref';
import { ElButton } from 'element-plus';


export default /*#__PURE__*/_defineComponent({
  __name: 'project-list',
  props: {
    title: {
        type: String,
        default: '',
    },
    imgPos: {
        type: String as PropType<'top' | 'left' | 'right' | 'bottom' | 'full'>,
        default: 'top',
    },
    imgHeight: {
        type: String,
        default: '152px',
    },
    imgWidth: {
        type: String,
        default: '285px',
    },
    request: {
        type: [String, Object] as PropType<string | { name: string; resultKey: string }>,
        default: '',
    },
    requestParams: {
        type: Object as PropType<Record<string, any>>,
        default: () => ({}),
    },
    list: {
        type: Array as PropType<any[]>,
        default: () => [],
    },
    columnsNum: {
        type: Number,
        default: 2,
    },
    border: {
        type: Boolean,
        default: true,
    },
},
  setup(__props) {

const props = __props;



const showList = ref<any[]>([]);
const codeVisible = ref(false);
const activeItem = ref<any>({});

const filterData = reactive({
    pageIndex: 1,
    pageSize: 4,
});

const getStyle = computed(() => {
    return `
        --img-height: ${props.imgHeight};
        --img-width: ${props.imgWidth};
        --content-width: ${['top', 'bottom'].includes(props.imgPos) ? props.imgWidth : 'auto'};
        --columns-num: ${props.columnsNum};
        --item-border: ${props.border ? '1px solid #eaeaea' : 'none'};
        `;
});

function getValueByPath(obj: any, path: string) {
    const keys = path.split('.');
    if (!keys.length) {
        return;
    }
    if (keys.length === 1) {
        return obj[path];
    }
    const value = keys.reduce((prev, current) => {
        return prev?.[current];
    }, obj);

    return value;
}

function getList() {
    const { requestParams = {}, request } = props;
    if (!request) {
        showList.value = props.list;
        return;
    }
    const requestName = isString(request) ? request : request.name;
    G_transmit(requestName, {
        params: {
            ...(requestParams.filter?.type === 'query' ? filterData : {}),
            ...(requestParams.params ?? {}),
        },
        data: {
            ...(requestParams.filter?.type === 'body' ? filterData : {}),
            ...(requestParams.data ?? {}),
        },
        message: false,
    }).then(res => {
        if (isObject(request)) {
            showList.value = getValueByPath(res, request.resultKey) ?? [];
        } else if (res.data && res.data.rows) {
            showList.value = res.data.rows || [];
        }
        console.log('showList: ', showList);
    });
}

function goDetail(item) {
    activeItem.value = item;
    if (item?.eventsId) {
        // 有赛事id则判断是否需要邀请码
        G_transmit('isSetInvite', {
            name: 'isSetInvite',
            queries: {
                projectId: item.id,
            },
        }).then(res => {
            if (res.data === true) {
                codeVisible.value = true;
            } else {
                // 不需要进行跳转
                if (item?.stageJson?.code >= 50) {
                    pageJump(
                        {
                            name: 'scientificResearchProjectGroup',
                            query: { id: item?.id, name: item?.projectName },
                        },
                        true,
                    );
                } else {
                    pageJump(
                        jumpHref.rating2.matchRatingDetail(item?.eventsId, {
                            projectType: item?.projectTypeJson?.code,
                        }),
                        true,
                    );
                }
            }
        });
    } else {
        G_dispatchEvent('toast', { message: '申报暂未开始', type: 'info' });
    }
}

function onClose() {
    codeVisible.value = false;
}

// 验证通过后
function onConfirm() {
    onClose();
    if (activeItem.value?.stageJson?.code >= 50) {
        pageJump(
            {
                name: 'scientificResearchProjectGroup',
                query: { id: activeItem.value?.id, name: activeItem.value?.projectName },
            },
            true,
        );
    } else {
        pageJump(
            jumpHref.rating2.matchRatingDetail(activeItem.value?.eventsId, {
                projectType: activeItem.value?.projectTypeJson?.code,
            }),
            true,
        );
    }
}

function moreHandle() {
    pageJump({ name: 'scientificResearchProjectCenter' }, true);
}

onMounted(() => {
    getList();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: "card-list-template",
    style: _normalizeStyle(_unref(getStyle))
  }, [
    _createVNode(CommonTitleTemplate, {
      title: __props.title,
      onGoMore: moreHandle
    }, null, 8, ["title"]),
    (showList.value?.length)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(showList.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              style: _normalizeStyle(_ctx.itemStyle),
              class: _normalizeClass([
                    'card-item',
                    {
                        'card-item-img-top': __props.imgPos === 'top',
                        'card-item-img-left': __props.imgPos === 'left',
                        'card-item-img-right': __props.imgPos === 'right',
                        'card-item-img-bottom': __props.imgPos === 'bottom',
                        'card-item-img-full': __props.imgPos === 'full',
                    },
                ]),
              onClick: ($event: any) => (goDetail(item))
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createVNode(LazyImage, {
                  src: item.projectLogo,
                  className: "img"
                }, null, 8, ["src"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createVNode(Ellipsis, {
                    rows: 2,
                    content: item.projectName ?? '-'
                  }, null, 8, ["content"])
                ]),
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_6, "阶段：" + _toDisplayString(item.stageJson?.name ?? '-'), 1),
                  _createElementVNode("div", _hoisted_7, "年份：" + _toDisplayString(item.projectYear ?? '-'), 1)
                ])
              ]),
              _createElementVNode("div", {
                class: _normalizeClass(['status-tag', { 'status-inprogress': item.stateName?.includes('中') }])
              }, _toDisplayString(item.stateName), 3)
            ], 14, _hoisted_2))
          }), 128))
        ]))
      : (_openBlock(), _createBlock(BigNoData, {
          key: 1,
          class: "no-data",
          url: "no-lesson.png",
          info: `暂无数据`
        })),
    _createVNode(CodeDialog, {
      onOnClose: onClose,
      onOnConfirm: onConfirm,
      visible: codeVisible.value,
      "project-detail": activeItem.value
    }, null, 8, ["visible", "project-detail"])
  ], 4))
}
}

})